import { render, staticRenderFns } from "./cModalStoreDispatchOthers.vue?vue&type=template&id=53142793&scoped=true&lang=es"
import script from "./cModalStoreDispatchOthers.vue?vue&type=script&lang=js"
export * from "./cModalStoreDispatchOthers.vue?vue&type=script&lang=js"
import style0 from "./cModalStoreDispatchOthers.vue?vue&type=style&index=0&id=53142793&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53142793",
  null
  
)

export default component.exports